import { render } from "./BlogComp.vue?vue&type=template&id=bb5a81d2"
import script from "./BlogComp.vue?vue&type=script&lang=js"
export * from "./BlogComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__